import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _cache = null;
let _pending = null;

async function fetchBrand() {
  try {
    const res = await axios.get(`${API}/platform/settings`);
    const s = res.data || {};
    const logoUrl = s.platform_logo ? `${API}/files/${s.platform_logo}` : null;
    return {
      // platform_favicon لا يوجد له واجهة تحديث حالياً في لوحة السوبر أدمن، لذا نعتمد على شعار المنصة القابل للتحديث كمرجع وحيد للهوية
      logoUrl,
      iconUrl: logoUrl,
      name: s.platform_name || 'تسيار',
    };
  } catch {
    return { logoUrl: null, iconUrl: null, name: 'تسيار' };
  }
}

export function getTasyarBrand() {
  if (_cache) return Promise.resolve(_cache);
  if (!_pending) _pending = fetchBrand().then((b) => { _cache = b; return b; });
  return _pending;
}

const DEFAULT_BRAND = { logoUrl: null, iconUrl: null, name: 'تسيار' };

export function useTasyarBrand() {
  const [brand, setBrand] = useState(_cache || DEFAULT_BRAND);
  useEffect(() => {
    let alive = true;
    getTasyarBrand().then((b) => { if (alive) setBrand(b); });
    return () => { alive = false; };
  }, []);
  return brand;
}
